import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selected: [],
    selectedNames: []
};

export const settingsCategoriesSelectedSlice = createSlice({
    name: 'settingsCategoriesSelected',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = settingsCategoriesSelectedSlice.actions

export default settingsCategoriesSelectedSlice.reducer